import { apiClient } from './client.js'
import { API_ENDPOINTS } from '../config/constants.js'
import type { EmptyResponse, FetchOptions } from '../models/common.js'
import type {
  RecoveryMethod,
  RecoveryRequestResponse,
  ResetPasswordPayload,
} from '../models/recovery.js'

export async function createRecoveryRequest(
  email: string,
  recoveryMethod?: RecoveryMethod,
  options: FetchOptions = {},
): Promise<RecoveryRequestResponse> {
  const payload: { email: string; recovery_method?: RecoveryMethod } = { email }
  if (recoveryMethod) {
    payload.recovery_method = recoveryMethod
  }

  return await apiClient.post<RecoveryRequestResponse>(
    API_ENDPOINTS.USER_RECOVERY_REQUESTS,
    payload,
    { signal: options.signal },
  )
}

export async function resetPassword(
  payload: ResetPasswordPayload,
  options: FetchOptions = {},
): Promise<void> {
  await apiClient.put<EmptyResponse>(API_ENDPOINTS.USER_RESET_PASSWORD, payload, {
    signal: options.signal,
  })
}
